export default class ProductCategoryFilter {
    constructor() {
        const filters = document.querySelectorAll('.woocommerce-filters__set');

        const closeAll = () => {
            filters.forEach(filter => {
                filter.querySelector('.woocommerce-filters__items')?.classList.remove('is-active');
            })
        }

        filters.forEach((filter) => {
            filter.addEventListener('click', (event) => {
                event.stopPropagation()
                const target = filter.querySelector('.woocommerce-filters__items')
                if (!target) return; // Exit if no filter was clicked

                if(target.classList.contains('is-active')) {
                    target.classList.remove('is-active');
                } else {
                    closeAll();
                    target.classList.add('is-active');
                }
    
            });
        })
    }
}
